import SubNav from "~/features/dashboard/components/sub-nav";
import { useAuth } from "~/providers/auth.provider";
import { AccountActions } from "../components/acount-actions";
import NotificationSettings from "../components/notifications";
import PersonalDetailsForm from "../components/settings-form";

const SettingsPage = () => {
  const { user, logout, deleteUserAccount } = useAuth();
  
  return (
    <main className="flex flex-col gap-6">
      <section className="py-10">

        <SubNav
          title="Settings"
          buttonOne={""}
          buttonTwo={""}
        />

        {/* Timeline */}
        <div className="space-y-8 flex-col lg:space-y-0 lg:space-x-6 flex lg:flex-row">
        <div className="h-full grow">
        <PersonalDetailsForm user={user} />
        </div>
        <div className="lg:space-y-3  space-y-8">
          <NotificationSettings />
          <AccountActions logout={logout} deleteAccount={deleteUserAccount}/>
        </div>
        </div>
      </section>
    </main>
  );
};

export default SettingsPage;
